<template>
    <div>
        <navbar-header page-name="Колл-центр"/>
        <order-info class="body"></order-info>
    </div>
</template>

<script>
import NavbarHeader from '@/components/NavbarHeader'
import OrderInfo from '@/components/OrderInfo'
export default {
  name: 'NewOrderLayout',
  data () {
    return {
    }
  },
  components: {
    OrderInfo,
    NavbarHeader
  }
}
</script>

<style scoped>
    .navbar-text {
        padding: 0 10px;
    }
</style>



// WEBPACK FOOTER //
// src/views/NewOrderLayout.vue